export default {
    meta: {
        title: '鱼你在一起-更换责任人'
    }
};
